import { get, post } from "../api/apiClient";
import StaffCreateRequest from "../form/request/StaffCreateRequest";
import StaffUpdateRequest from "../form/request/StaffUpdateRequest";
import StaffStopRequest from "../form/request/StaffStopRequest";
import { authHeader } from "../api/authHeader";

const API_PREFIX = "/staff";

export const create = async request => {
  const response = await post(`${API_PREFIX}/create`, new StaffCreateRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const uploadFile = async request => {
  const response = await post(`${API_PREFIX}/uploadFile`, request, authHeader());
  console.log("response", response);
  return response.data;
};

export const search = async request => {
  console.log("request", request);
  var requestUrl =
    "?serialNumber=" +
    request.serialNumber +
    "&belongs=" +
    request.belongs +
    "&name=" +
    request.name +
    "&endDateFlg=" +
    request.endDateFlg;
  const response = await get(`${API_PREFIX}/search${requestUrl}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async request => {
  console.log("request", request);
  const response = await post(`${API_PREFIX}/update`, new StaffUpdateRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const stop = async request => {
  console.log("request", request);
  const response = await post(`${API_PREFIX}/stop`, new StaffStopRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const sampleExcelDownload = async () => {
  const response = await get(`${API_PREFIX}/generate`, authHeader());
  console.log("response", response);
  return response.data;
};
